<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createDesignWorldCalendarData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tr v-for="(item,index) in dataTable">
            <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td width="40%">{{item.name_en}}</td>
            <td width="25%">{{item.location}}</td>
            <td>{{item.event_date | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showDesignWorldCalendarData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          <tbody>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import InputSearch from "../../components/Input/InputSearch";
    import CircleButton from "../../components/Button/CircleButton";
    import IconPencil from "../../components/Icon/icon-pencil";
    import Paginate from "../../components/Layout/Paginate";
    export default {
        name: "DesignWorldCalendarTable",
      components: {Paginate, IconPencil, CircleButton, InputSearch},
      data() {
        return {
          title: "Design world calendar",
          headers: [
            { id: 1, text: "No." },
            { id: 2, text: "Title" },
            { id: 3, text: "Location" },
            { id: 4, text: "Publish date" },
            { id: 5, text: "Edit" }
          ],
          dataTable: [],
          dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
          }
        };
      },
      created() {
          this.getDesignWorldCalendarTable(1);
      },
      methods:{
        getDesignWorldCalendarTable(page){
          this.$store.dispatch("DesignWorldCalendar/getDesignWorldCalendar",page).then(res=>{
            if(res.response_code == 200){
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }
          }).catch(()=>{
            alert('cannot to get Design world calendar data');
          });
        },
        changePage(val){
          this.dataPaginate.current_page = val;
          this.$store.dispatch("DesignWorldCalendar/getDesignWorldCalendar", this.dataPaginate.current_page).then(res => {
            if (res.response_code == 200) {
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            } else {
              alert(res.response_msg);
            }
          });
        },
        goToDesignWorldCalendarEdit(){
          this.$router.push("/design-world-calendar/edit");
        },
        showDesignWorldCalendarData(id){
          this.$store.dispatch("DesignWorldCalendar/showDesignWorldCalendar",id).then(res=>{
            if(res.response_code == 200){
              this.$store.dispatch("DesignWorldCalendar/setFormDesignWorldCalendar",res.result).then(()=>{
                this.goToDesignWorldCalendarEdit();
              })
            }
          }).catch(()=>{
            alert('cannot to get Design world calendar data');
          });
        },
        createDesignWorldCalendarData(){
          this.$store.dispatch("DesignWorldCalendar/clearFormData").then(()=>{
            this.goToDesignWorldCalendarEdit();
          })
        },
      }
    }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
